import React from 'react'

const VirtualPortalFooter = () => {
  if(window.visitingOneOnOneWizardFrom) return ''

  return (
    <div>
      <footer className="virtual-footer">
        <p className="copyright">
          &copy; {new Date().getFullYear()} Gartner, Inc. and/or its affiliates.
          All rights reserved. View our{' '}
          <a
            href="https://www.evanta.com/terms/privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>{' '}
          or{' '}
          <a
            href="https://www.evanta.com/terms/terms-and-conditions"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms and Conditions
          </a>
          .
        </p>
      </footer>
    </div>
  )
} 

export default VirtualPortalFooter
